var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnoycamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0.875V5.54167C21 6.02467 21.392 6.41667 21.875 6.41667C22.358 6.41667 22.75 6.02467 22.75 5.54167V0.875C22.75 0.392 22.358 0 21.875 0C21.392 0 21 0.392 21 0.875Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5415 4.08301H24.2082C24.6912 4.08301 25.0832 3.69101 25.0832 3.20801C25.0832 2.72501 24.6912 2.33301 24.2082 2.33301H19.5415C19.0585 2.33301 18.6665 2.72501 18.6665 3.20801C18.6665 3.69101 19.0585 4.08301 19.5415 4.08301Z",
    fill: "#373737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.346 5.24501C24.3005 5.24851 24.255 5.24967 24.2083 5.24967H23.9167V5.54134C23.9167 6.66834 23.002 7.58301 21.875 7.58301C20.748 7.58301 19.8333 6.66834 19.8333 5.54134V5.24967H19.5417C18.4147 5.24967 17.5 4.33501 17.5 3.20801C17.5 2.76351 17.6423 2.35284 17.8827 2.01801L17.7298 1.71117C17.3845 1.02051 16.6775 0.583008 15.904 0.583008C14.3558 0.583008 10.7275 0.583008 9.17933 0.583008C8.40583 0.583008 7.69883 1.02051 7.3535 1.71117L6.24867 3.92201C6.1985 4.02001 6.09817 4.08301 5.98733 4.08301H3.20833C1.43617 4.08301 0 5.51917 0 7.29134V18.958C0 19.8085 0.338333 20.6252 0.939167 21.2272C1.54117 21.828 2.35783 22.1663 3.20833 22.1663H21.875C22.7255 22.1663 23.5422 21.828 24.1442 21.2272C24.745 20.6252 25.0833 19.8085 25.0833 18.958V7.29134C25.0833 6.51318 24.8068 5.80034 24.346 5.24501ZM12.5417 6.99967C9.48267 6.99967 7 9.48234 7 12.5413C7 15.6003 9.48267 18.083 12.5417 18.083C15.6007 18.083 18.0833 15.6003 18.0833 12.5413C18.0833 9.48234 15.6007 6.99967 12.5417 6.99967ZM12.5417 8.74967C14.6347 8.74967 16.3333 10.4483 16.3333 12.5413C16.3333 14.6343 14.6347 16.333 12.5417 16.333C10.4487 16.333 8.75 14.6343 8.75 12.5413C8.75 10.4483 10.4487 8.74967 12.5417 8.74967Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnoycamera);
export default __webpack_public_path__ + "static/media/annoycamera.b4aa2258bbca8041b1e5d305f703c79d.svg";
export { ForwardRef as ReactComponent };